import { useState } from 'react'
import { useSetPopup } from '../../contexts'
import { Box, Button, InputField, Modal } from '..'
import { Text } from 'tusk-ui'
import { useField } from '../../hooks'
import { useCustomMutation } from '../../gql/clients'
import { LEAVE_FEEDBACK_MUTATION } from '../../gql/leaveFeedbackMutation'
import PeopleCelebrate from '../icons/PeopleCelebrate'
import { useEngagementDetails } from '../../gql/employeePoints'
import { EngagementTypes } from '../../types'
import Theme from '../../theme'
import { NavigationContent } from 'mammoth/components/Navigation/Navigation'

const FeedbackPopup = ({ content }: { content: NavigationContent['feedbackPopup'] }) => {
    const setPopup = useSetPopup()
    const [leaveFeedback] = useCustomMutation(LEAVE_FEEDBACK_MUTATION)
    const [loading, setLoading] = useState(false)
    const [feedback, setFeedback, feedbackError, setFeedbackError] = useField()
    const [sent, setSent] = useState(false)

    const engagementDetails = useEngagementDetails()
    const pointsText = `(${engagementDetails[EngagementTypes.SiteFeedbackSubmission]?.Formatted_Points})`

    const submit = async () => {
        setSent(false)
        setLoading(true)
        try {
            await leaveFeedback({
                variables: {
                    feedback
                }
            })
            setFeedback('')
            setSent(true)
        } catch (err) {
            console.error(err)
        }
        setLoading(false)
    }
    const clearError =
        (
            setValue: React.Dispatch<React.SetStateAction<string>>,
            error: string,
            setError: React.Dispatch<React.SetStateAction<string>>
        ) =>
        (value: string) => {
            if (error) setError('')
            setValue(value)
        }

    return (
        <Modal
            Type='GIVE_FEEDBACK_POPUP'
            Heading={!sent ? content.heading : content.sentSubheading}
            maxWidth={800}
            height='auto'
            onClose={() => {
                setPopup(null)
                setSent(false)
                setFeedback('')
            }}
        >
            <Box mb={4}>
                {!sent ? (
                    <Text variant='l2'>{content.sendHeading}</Text>
                ) : (
                    <Text variant='b4'>{content.sentSubheading}</Text>
                )}
            </Box>
            <Box flexGrow={1} flex={1} mb={4} justifyContent='center' display='flex'>
                {!sent ? (
                    <InputField
                        placeHolder={content.placeholder}
                        value={feedback}
                        onChange={clearError((e) => setFeedback(e), feedbackError, setFeedbackError)}
                        error={feedbackError}
                        rows={6}
                        style={{ borderColor: Theme.Colors['Grey400'] }}
                    />
                ) : (
                    <PeopleCelebrate />
                )}
            </Box>
            {!sent && (
                <Box pt={4} display='flex' justifyContent='flex-end'>
                    <Button disabled={loading} onClick={loading ? undefined : submit} size='sm'>
                        {`${content.submit} ${pointsText}`}
                    </Button>
                </Box>
            )}
        </Modal>
    )
}

export default FeedbackPopup
